import competitionActionTypes from "./competitions.types";

const INITIAL_STATE = {
  isSubmitting: false,
  isFetching: false,
  error: undefined,
  success: undefined,
  createdCompetition: null,
  competitionDetail: null,
  myEvents: { tournaments: [], challenges: [], oneVOnes: [], pagination: null },
  publicEvents: { events: [], pagination: null, eventType: null },
  publicEventsFetching: false,
  publicChallenges: { events: [], pagination: null },
  publicChallengesFetching: false,
  publicOneVOnes: { events: [], pagination: null },
  publicOneVOnesFetching: false,
  platforms: [],
  platformsLoading: false,
  categories: [],
  categoriesLoading: false,
  supportedGames: [],
  supportedGamesLoading: false,
  // Challenge state
  challengeLadder: null,
  challengeLadderLoading: false,
};

const competitionsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case competitionActionTypes.CREATE_TOURNAMENT_START:
    case competitionActionTypes.CREATE_CHALLENGE_START:
    case competitionActionTypes.CREATE_ONE_V_ONE_START:
    case competitionActionTypes.JOIN_COMPETITION_START:
    case competitionActionTypes.REPORT_SCORE_START:
    case competitionActionTypes.SUBMIT_DISPUTE_EVIDENCE_START:
    case competitionActionTypes.FETCH_COMPETITIONS_START:
    case competitionActionTypes.DELETE_COMPETITION_START:
    case competitionActionTypes.EDIT_COMPETITION_START:
    case competitionActionTypes.PUBLISH_COMPETITION_START:
      return {
        ...state,
        isSubmitting: true,
        error: undefined,
        success: undefined,
      };
    case competitionActionTypes.FETCH_COMPETITION_DETAIL_START:
    case competitionActionTypes.FETCH_MY_EVENTS_START:
      return {
        ...state,
        isFetching: true,
        error: undefined,
      };
    case competitionActionTypes.CREATE_TOURNAMENT_SUCCESS:
    case competitionActionTypes.CREATE_CHALLENGE_SUCCESS:
    case competitionActionTypes.CREATE_ONE_V_ONE_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        success: "Competition created successfully!",
        createdCompetition: action.payload,
      };
    case competitionActionTypes.JOIN_COMPETITION_SUCCESS:
    case competitionActionTypes.REPORT_SCORE_SUCCESS:
    case competitionActionTypes.SUBMIT_DISPUTE_EVIDENCE_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        success: "Update successful!",
        competitionDetail: action.payload,
      };
    case competitionActionTypes.FETCH_COMPETITIONS_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        // Handle listing if needed
      };
    case competitionActionTypes.FETCH_MY_EVENTS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        myEvents: action.payload,
      };
    case competitionActionTypes.FETCH_COMPETITION_DETAIL_SUCCESS:
      return {
        ...state,
        isFetching: false,
        competitionDetail: action.payload,
      };
    case competitionActionTypes.DELETE_COMPETITION_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        success: action.payload,
        competitionDetail: null,
      };
    case competitionActionTypes.EDIT_COMPETITION_SUCCESS:
    case competitionActionTypes.PUBLISH_COMPETITION_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        success: "Update successful!",
        competitionDetail: action.payload,
      };
    case competitionActionTypes.CREATE_TOURNAMENT_FAILURE:
    case competitionActionTypes.CREATE_CHALLENGE_FAILURE:
    case competitionActionTypes.CREATE_ONE_V_ONE_FAILURE:
    case competitionActionTypes.JOIN_COMPETITION_FAILURE:
    case competitionActionTypes.REPORT_SCORE_FAILURE:
    case competitionActionTypes.SUBMIT_DISPUTE_EVIDENCE_FAILURE:
    case competitionActionTypes.FETCH_COMPETITIONS_FAILURE:
    case competitionActionTypes.DELETE_COMPETITION_FAILURE:
    case competitionActionTypes.EDIT_COMPETITION_FAILURE:
    case competitionActionTypes.PUBLISH_COMPETITION_FAILURE:
    case competitionActionTypes.UPLOAD_COMPETITION_IMAGES_FAILURE:
      return {
        ...state,
        isSubmitting: false,
        error:
          typeof action.payload === "object" &&
          action.payload !== null &&
          action.payload.message
            ? action.payload.message
            : action.payload,
        errorData:
          typeof action.payload === "object" &&
          action.payload !== null &&
          action.payload.data
            ? action.payload.data
            : null,
      };
    case competitionActionTypes.FETCH_COMPETITION_DETAIL_FAILURE:
    case competitionActionTypes.FETCH_MY_EVENTS_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    case competitionActionTypes.FETCH_PLATFORMS_START:
      return {
        ...state,
        platformsLoading: true,
      };
    case competitionActionTypes.FETCH_PLATFORMS_SUCCESS:
      return {
        ...state,
        platformsLoading: false,
        platforms: action.payload,
      };
    case competitionActionTypes.FETCH_PLATFORMS_FAILURE:
      return {
        ...state,
        platformsLoading: false,
      };
    case competitionActionTypes.FETCH_CATEGORIES_START:
      return {
        ...state,
        categoriesLoading: true,
      };
    case competitionActionTypes.FETCH_CATEGORIES_SUCCESS:
      return {
        ...state,
        categoriesLoading: false,
        categories: action.payload,
      };
    case competitionActionTypes.FETCH_CATEGORIES_FAILURE:
      return {
        ...state,
        categoriesLoading: false,
      };
    case competitionActionTypes.FETCH_SUPPORTED_GAMES_START:
      return {
        ...state,
        supportedGamesLoading: true,
      };
    case competitionActionTypes.FETCH_SUPPORTED_GAMES_SUCCESS:
      return {
        ...state,
        supportedGamesLoading: false,
        supportedGames: action.payload,
      };
    case competitionActionTypes.FETCH_SUPPORTED_GAMES_FAILURE:
      return {
        ...state,
        supportedGamesLoading: false,
      };
    case competitionActionTypes.CLEAR_COMPETITION_MESSAGES:
      return {
        ...state,
        error: undefined,
        success: undefined,
      };
    case competitionActionTypes.UPLOAD_COMPETITION_IMAGES_START:
      return {
        ...state,
        isSubmitting: true,
        error: undefined,
      };
    case competitionActionTypes.UPLOAD_COMPETITION_IMAGES_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        success: "Images uploaded successfully!",
        createdCompetition: action.payload,
      };
    case competitionActionTypes.UPLOAD_COMPETITION_IMAGES_FAILURE:
      return {
        ...state,
        isSubmitting: false,
        error: action.payload,
      };
    case competitionActionTypes.CLEAR_CREATED_COMPETITION:
      return {
        ...state,
        createdCompetition: null,
        success: undefined,
      };
    case competitionActionTypes.FETCH_PUBLIC_EVENTS_START:
      return {
        ...state,
        publicEventsFetching: true,
        error: undefined,
      };
    case competitionActionTypes.FETCH_PUBLIC_EVENTS_SUCCESS:
      return {
        ...state,
        publicEventsFetching: false,
        publicEvents: {
          events: action.payload.events,
          pagination: action.payload.pagination,
          eventType: action.payload.eventType,
        },
      };
    case competitionActionTypes.FETCH_PUBLIC_EVENTS_FAILURE:
      return {
        ...state,
        publicEventsFetching: false,
        error: action.payload,
      };
    // Homepage: dedicated challenges slice
    case competitionActionTypes.FETCH_PUBLIC_CHALLENGES_START:
      return { ...state, publicChallengesFetching: true, error: undefined };
    case competitionActionTypes.FETCH_PUBLIC_CHALLENGES_SUCCESS:
      return {
        ...state,
        publicChallengesFetching: false,
        publicChallenges: {
          events: action.payload.events,
          pagination: action.payload.pagination,
        },
      };
    case competitionActionTypes.FETCH_PUBLIC_CHALLENGES_FAILURE:
      return { ...state, publicChallengesFetching: false, error: action.payload };
    // Homepage: dedicated 1v1 slice
    case competitionActionTypes.FETCH_PUBLIC_ONE_V_ONES_START:
      return { ...state, publicOneVOnesFetching: true, error: undefined };
    case competitionActionTypes.FETCH_PUBLIC_ONE_V_ONES_SUCCESS:
      return {
        ...state,
        publicOneVOnesFetching: false,
        publicOneVOnes: {
          events: action.payload.events,
          pagination: action.payload.pagination,
        },
      };
    case competitionActionTypes.FETCH_PUBLIC_ONE_V_ONES_FAILURE:
      return { ...state, publicOneVOnesFetching: false, error: action.payload };
    // Challenge Ladder Cases
    case competitionActionTypes.FETCH_CHALLENGE_LADDER_START:
      return {
        ...state,
        challengeLadderLoading: true,
        error: undefined,
      };
    case competitionActionTypes.FETCH_CHALLENGE_LADDER_SUCCESS:
      return {
        ...state,
        challengeLadderLoading: false,
        challengeLadder: action.payload,
      };
    case competitionActionTypes.FETCH_CHALLENGE_LADDER_FAILURE:
      return {
        ...state,
        challengeLadderLoading: false,
        error: action.payload,
      };
    case competitionActionTypes.CLEAR_CHALLENGE_LADDER:
      return {
        ...state,
        challengeLadder: null,
        challengeLadderLoading: false,
      };
    // Challenge winner/lifecycle management - use generic handlers
    case competitionActionTypes.SUBMIT_CHALLENGE_WINNER_START:
    case competitionActionTypes.VERIFY_CHALLENGE_WINNER_START:
    case competitionActionTypes.ADVANCE_CHALLENGE_ROUND_START:
    case competitionActionTypes.VERIFY_CHALLENGE_START:
    case competitionActionTypes.COMMENCE_CHALLENGE_START:
    case competitionActionTypes.END_CHALLENGE_START:
      return {
        ...state,
        isSubmitting: true,
        error: undefined,
        success: undefined,
      };
    case competitionActionTypes.SUBMIT_CHALLENGE_WINNER_SUCCESS:
    case competitionActionTypes.VERIFY_CHALLENGE_WINNER_SUCCESS:
    case competitionActionTypes.ADVANCE_CHALLENGE_ROUND_SUCCESS:
    case competitionActionTypes.VERIFY_CHALLENGE_SUCCESS:
    case competitionActionTypes.COMMENCE_CHALLENGE_SUCCESS:
    case competitionActionTypes.END_CHALLENGE_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        success: "Challenge updated successfully!",
        competitionDetail: action.payload || state.competitionDetail,
      };
    case competitionActionTypes.SUBMIT_CHALLENGE_WINNER_FAILURE:
    case competitionActionTypes.VERIFY_CHALLENGE_WINNER_FAILURE:
    case competitionActionTypes.ADVANCE_CHALLENGE_ROUND_FAILURE:
    case competitionActionTypes.VERIFY_CHALLENGE_FAILURE:
    case competitionActionTypes.COMMENCE_CHALLENGE_FAILURE:
    case competitionActionTypes.END_CHALLENGE_FAILURE:
      return {
        ...state,
        isSubmitting: false,
        error: action.payload,
      };
    // Unsubscribe cases
    case competitionActionTypes.UNSUBSCRIBE_COMPETITION_START:
      return {
        ...state,
        isSubmitting: true,
        error: undefined,
        success: undefined,
      };
    case competitionActionTypes.UNSUBSCRIBE_COMPETITION_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        success: action.payload || "Successfully unsubscribed!",
      };
    case competitionActionTypes.UNSUBSCRIBE_COMPETITION_FAILURE:
      return {
        ...state,
        isSubmitting: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default competitionsReducer;
